export enum PermissionEnum {
  VIEW = 'view',
  CREATE = 'create',
  UPDATE = 'update',
  REMOVE = 'remove',
  EXPORT = 'export',
}

export enum ResourceEnum {
  USERS = 'users',
  COURSES = 'courses',
  TRACKS = 'tracks',
  CATEGORIES = 'categories',
  TAGS = 'tags',
  PROFILE = 'profile',
  DASHBOARD = 'dashboard',
}

export type IamPermissionMap = Partial<Record<ResourceEnum, Partial<Record<PermissionEnum, string[]>>>>;

const permissionBase: IamPermissionMap = {
  [ResourceEnum.USERS]: {
    [PermissionEnum.VIEW]: ['admin:users:read'],
    [PermissionEnum.CREATE]: ['admin:users:create'],
    [PermissionEnum.UPDATE]: ['admin:users:update'],
    [PermissionEnum.REMOVE]: ['admin:users:delete'],
  },
  [ResourceEnum.COURSES]: {
    [PermissionEnum.VIEW]: ['admin:courses:read'],
    [PermissionEnum.CREATE]: ['admin:courses:create'],
    [PermissionEnum.UPDATE]: ['admin:courses:update'],
    [PermissionEnum.REMOVE]: ['admin:courses:delete'],
  },
  [ResourceEnum.TRACKS]: {
    [PermissionEnum.VIEW]: ['admin:tracks:read'],
    [PermissionEnum.CREATE]: ['admin:tracks:create'],
    [PermissionEnum.UPDATE]: ['admin:tracks:update'],
    [PermissionEnum.REMOVE]: ['admin:tracks:delete'],
  },
  [ResourceEnum.CATEGORIES]: {
    [PermissionEnum.VIEW]: ['admin:categories:read'],
    [PermissionEnum.CREATE]: ['admin:categories:create'],
    [PermissionEnum.UPDATE]: ['admin:categories:update'],
    [PermissionEnum.REMOVE]: ['admin:categories:delete'],
  },
  [ResourceEnum.TAGS]: {
    [PermissionEnum.VIEW]: ['admin:tags:read'],
    [PermissionEnum.CREATE]: ['admin:tags:create'],
    [PermissionEnum.UPDATE]: ['admin:tags:update'],
    [PermissionEnum.REMOVE]: ['admin:tags:delete'],
  },
  [ResourceEnum.PROFILE]: {
    [PermissionEnum.VIEW]: ['admin:dashboard:view'],
    [PermissionEnum.UPDATE]: ['admin:users:update'],
  },
  [ResourceEnum.DASHBOARD]: {
    [PermissionEnum.VIEW]: ['admin:dashboard:view'],
  },
};

export const permissionDev = (): IamPermissionMap => permissionBase;
export const permissionQas = (): IamPermissionMap => permissionBase;
export const permissionStaging = (): IamPermissionMap => permissionBase;
export const permissionProd = (): IamPermissionMap => permissionBase;
